import { Typography } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { colors, Icon, responsive } from '@/utils';

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(35rem, 1fr));
  gap: ${responsive.spacing['large']};
  width: 100%;
`;

export const StyledBody = styled.div`
  width: 100%;
  display: grid;
  gap: 0.5rem;
  padding: ${responsive.spacing['3xlarge']};
`;

export const EnvironmentSensorValuesOnVideo = styled(Typography)`
  color: ${colors.text.neutral.on.solid[100]};
  display: flex;
  white-space: nowrap;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
`;

export const EnvironmentSensorValues = styled(Typography)`
  color: ${colors.text.neutral[100]};
  display: flex;
  white-space: nowrap;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
`;

export const OrbitLedValues = styled(Typography)`
  color: ${colors.text.neutral[100]};
  display: flex;
  white-space: nowrap;
  cursor: pointer;
`;

export const ValuesContainer = styled.div`
  display: flex;
  gap: 0.4rem;
  align-items: center;
`;

export const NameAndType = styled.div`
  display: flex;
  gap: ${responsive.spacing['large']};
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
`;

export const ValuesInfoContainer = styled.div`
  display: flex;
  gap: ${responsive.spacing['medium']};
  align-items: center;
`;

/** Rows of {@link EnvironmentSensor}: shared columns so metrics line up across sensors on the same pen card. */
export const EnvironmentSensorsGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) repeat(3, minmax(4.5rem, max-content));
  column-gap: ${responsive.spacing.medium};
  row-gap: 0.5rem;
  align-items: center;
`;

export const EnvironmentSensorRowRoot = styled.div`
  display: contents;
`;

export const StyledWarningIcon = styled(Icon.OctagonAlert).attrs({ size: 'large' })`
  width: 18px;
  height: 18px;
  color: ${colors.icon.alarm[100]};
`;
